module.exports = __webpack_public_path__ + "img/evalution-view@2x.80f373a0.png";